import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from './MetaPixel';
export function PricingCTA() {
  return <section id="pricing" className="bg-primary py-10 md:py-16 px-4 md:px-12 scroll-mt-20" data-id="element-233">
      <div className="max-w-3xl mx-auto flex flex-col items-center" data-id="element-234">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="w-full bg-secondary border border-gold rounded-2xl p-6 md:p-10 shadow-glow-gold relative overflow-hidden text-center" data-id="element-235">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-gold-dark via-gold to-gold-dark" data-id="element-236"></div>

          <div className="font-inter text-warm-disabled line-through text-lg md:text-xl mb-2" data-id="element-237">
            Antes: $37
          </div>

          <div className="font-playfair font-bold text-3xl md:text-4xl text-warm-white mb-4" data-id="element-238">
            Precio de prueba hoy:{' '}
            <span className="text-gold font-extrabold text-5xl md:text-6xl block mt-2" data-id="element-239">
              $6.39
            </span>
          </div>

          <p className="font-inter text-base md:text-lg text-warm-muted mb-4" data-id="element-240">
            Empieza por menos de lo que gastas en cualquier cosa diaria.
          </p>
          <p className="font-playfair italic text-lg md:text-xl text-gold mb-8" data-id="element-241">
            Empieza hoy a cambiar ese patrón.
          </p>

          <a href="https://pay.hotmart.com/I105463361U?checkoutMode=10" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="block w-full text-center bg-gold hover:bg-gold-light transition-all text-primary font-inter font-bold text-sm md:text-base px-4 py-4 md:py-5 rounded-xl shadow-glow-gold hover:shadow-glow-gold-lg transform hover:-translate-y-1" data-id="element-242">
            QUIERO DEJAR DE PERDER DINERO SIN DARME CUENTA
          </a>
        </motion.div>
      </div>
    </section>;
}